import styled from "styled-components";

import { VOTEBOX_FONT_WEIGHT_SEMIBOLD } from "./voteboxTokens";

// Default line height, so that the message fits in the space kept for it and the button does not move.
export const StatusText = styled.p`
    font-weight: ${VOTEBOX_FONT_WEIGHT_SEMIBOLD};
`;
